export const ClosedOpsgenieIncidentStatus = 'closed' as const;
export const OpenOpsgenieIncidentStatus = 'open' as const;
export const ResolvedOpsgenieIncidentStatus = 'resolved' as const;

export const IncidentCommandCenterExtend = 'icc' as const;
export const PACKAGE_NAME = 'jiraServicedeskIncidentManagementServices';
